import React from "react";
import "./QuestionDropDown.css";
import DownArrow from "../../assets/dropdown2.svg";

const QuestionDropDown = (props) => {
  return (
    <>
      <div style={{ position: "static", maxHeight: "45rem" }}>
        {/* <div className="backdrop" > */}
        <div className="textarea" onClick={props.onClick}>
          <div className="Q non-selectable">
            <p className="Q-text">{props.Q}</p>
          </div>
          <div className="dropdown-button non-selectable">
            <img style={{ width: "45px" }} src={DownArrow} alt="Click Me" />
          </div>
        </div>
        {/* </div> */}

        {/* drop down answer */}
        <div>
          <div className={`answer-content ${!props.open ? "hide" : "show"}`}>
            <p className="A non-selectable">{props.A}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionDropDown;
